export const navToggle = () => {
  const hamburger = document.querySelector(".hamburger");
  const headerNav = document.querySelector(".header__menu");
  hamburger.addEventListener("click", function () {
    hamburger.classList.toggle("is-active");
    hamburger.ariaExpanded = false;
    headerNav.classList.toggle("is-active");
  });
};
